import { useTranslation } from 'react-i18next';
import { ACURA_SITE_NAME, HONDA_SITE_NAME } from '../../utils/constants';
import { useAppName } from '../../utils/sitecoreContext';
import { variant1, variant2 } from './constants';
const useGetVariant = () => {
    const appName = useAppName();
    switch (appName) {
        case ACURA_SITE_NAME:
            return variant1;
        case HONDA_SITE_NAME:
            return variant1;
        default:
            return variant2;
    }
};
const useSellingPriceConfiguration = () => {
    const { t } = useTranslation();
    const variant = useGetVariant();
    switch (variant) {
        case variant2:
            return { sellingPriceTooltipLabelValue: t('Shared.Common.sellingPriceDisclaimerNoTaxLabel') };
        default:
            return { sellingPriceTooltipLabelValue: t('Shared.Common.sellingPriceTooltipLabel') };
    }
};
export default useSellingPriceConfiguration;
